import { clone, path, pathOr } from 'ramda';
import {
	CLEAR_BLACKBAUD_USERS,
	CLEAR_BLACKBAUD_USER_UPDATE_ERRORS,
	CLEAR_BLACKBAUD_USER_CREATE_ERRORS,
	GET_BLACKBAUD_USER,
	GET_BLACKBAUD_USERS,
	FETCH_BLACKBAUD_USER_FAILED,
	FETCH_BLACKBAUD_USERS_FAILED,
	FETCH_BLACKBAUD_USER_SUCCEEDED,
	FETCH_BLACKBAUD_USERS_SUCCEEDED,
	UPDATE_BLACKBAUD_USER,
	UPDATE_BLACKBAUD_USER_FAILED,
	UPDATE_BLACKBAUD_USER_SUCCEEDED,
	CREATE_BLACKBAUD_USER,
	CREATE_BLACKBAUD_USER_FAILED,
	CREATE_BLACKBAUD_USER_SUCCEEDED,
} from './blackbaudUser.action';
import { blackbaudUsersInitialState } from './blackbaudUser.initialState';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const blackbaudUserReducer = (state = blackbaudUsersInitialState, action) => {
	switch (action.type) {
		case CLEAR_BLACKBAUD_USERS: {
			return {
				...state,
				...blackbaudUsersInitialState,
			};
		}

		case CLEAR_BLACKBAUD_USER_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_BLACKBAUD_USER_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case GET_BLACKBAUD_USER:
		case GET_BLACKBAUD_USERS: {
			return createPendingState(state, 'pendingFetch');
		}

		case FETCH_BLACKBAUD_USER_FAILED:
		case FETCH_BLACKBAUD_USERS_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_BLACKBAUD_USER_SUCCEEDED: {
			const fetchedBlackbaudUserId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingFetch: false,
			};
			if (fetchedBlackbaudUserId) {
				newState.entities = {
					...state.entities,
					[fetchedBlackbaudUserId]: action.payload,
				};
			}

			return newState;
		}

		case FETCH_BLACKBAUD_USERS_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			return {
				...state,
				entities,
				pendingFetch: false,
			};
		}

		case UPDATE_BLACKBAUD_USER: {
			return createPendingState(state, 'pendingUpdate');
		}

		case UPDATE_BLACKBAUD_USER_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case UPDATE_BLACKBAUD_USER_SUCCEEDED: {
			const updatedBlackbaudUserId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedBlackbaudUserId) {
				newState.entities = {
					...state.entities,
					[updatedBlackbaudUserId]: action.payload,
				};
			}

			return newState;
		}

		case CREATE_BLACKBAUD_USER: {
			return createPendingState(state, 'pendingCreate');
		}

		case CREATE_BLACKBAUD_USER_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case CREATE_BLACKBAUD_USER_SUCCEEDED: {
			const createdBlackbaudUserId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingCreate: false,
			};

			if (createdBlackbaudUserId) {
				newState.entities = {
					...state.entities,
					[createdBlackbaudUserId]: action.payload,
				};
			}

			return newState;
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/blackbaudUsers/blackbaudUser.reducer.js